import { useEventModal } from './useEventModal';
import './EventModal.scss';

export { useEventModal };
export default useEventModal;
